export default mods => {
    if(!window.$linkdesign){
        window.$linkdesign = {};
    }

    Object.keys(mods).forEach(modName => {
        if(window.$linkdesign[modName]){
            if(document.currentScript){
                console.warn(`${modName}重复引用，from:${document.currentScript.src}`);
            }else{
                console.warn(`${modName}重复引用`);
            }
        }
    });

    Object.assign(window.$linkdesign, mods);
}


// WEBPACK FOOTER //
// ./utils/export.js